import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICatalog = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width={props.width??"14"} height={props.height??"14"} viewBox="0 0 19 19" fill="none">
          <rect x="1" y="1" width="6" height="6" stroke={props.color??"#37474F"} strokeWidth="2"/>
          <rect x="1" y="12" width="6" height="6" stroke={props.color??"#37474F"} strokeWidth="2"/>
          <rect x="12" y="1" width="6" height="6" stroke={props.color??"#37474F"} strokeWidth="2"/>
          <rect x="12" y="12" width="6" height="6" stroke={props.color??"#37474F"} strokeWidth="2"/>
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ICatalog;
